"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertiesPostAddressMatchV2PropertiesAddressMatchV2ExactPost = propertiesPostAddressMatchV2PropertiesAddressMatchV2ExactPost;
const encodings_js_1 = require("../lib/encodings.js");
const M = __importStar(require("../lib/matchers.js"));
const primitives_js_1 = require("../lib/primitives.js");
const schemas_js_1 = require("../lib/schemas.js");
const security_js_1 = require("../lib/security.js");
const url_js_1 = require("../lib/url.js");
const errors = __importStar(require("../sdk/models/errors/index.js"));
const operations = __importStar(require("../sdk/models/operations/index.js"));
const async_js_1 = require("../sdk/types/async.js");
/**
 * Post Address Match v2
 *
 * @remarks
 * Get details of a property using a user provided address string & postcode.
 *
 * - This endpoint is functionally equivalent to [Get Property Details](#tag/properties/GET/properties/{street_group_property_id}) except a request body is sent
 * containing a user address string and a postcode.
 * -  The corresponding `street_group_property_id` will be looked up and the property fields are returned using the `street_group_property_id`.
 * -  A `fields[property]` parameter can be passed to return a subset of property attributes in the response.
 *
 * ### 429 Too Many Requests
 *
 * <details>
 * <summary>Click to view information on handling HTTP 429s when using this endpoint</summary>
 *
 * There is a limit set to how many requests to this endpoint can be made in a given minute. This endpoint can return
 * a 429 if this limit is reached and is shared across all users of Kraken. The current limit is
 * `800000/minute`.
 *
 * While it's not common to hit this limit you should implement a retry with increasing delay intervals to handle
 * a 429 response.
 *
 * </details>
 */
function propertiesPostAddressMatchV2PropertiesAddressMatchV2ExactPost(client, security, addressMatchPostRequest, fieldsProperty, options) {
    return new async_js_1.APIPromise($do(client, security, addressMatchPostRequest, fieldsProperty, options));
}
async function $do(client, security, addressMatchPostRequest, fieldsProperty, options) {
    const input = {
        addressMatchPostRequest: addressMatchPostRequest,
        fieldsProperty: fieldsProperty,
    };
    const parsed = (0, schemas_js_1.safeParse)(input, (value) => operations
        .PostAddressMatchV2PropertiesAddressMatchV2ExactPostRequest$outboundSchema
        .parse(value), "Input validation failed");
    if (!parsed.ok) {
        return [parsed, { status: "invalid" }];
    }
    const payload = parsed.value;
    const body = (0, encodings_js_1.encodeJSON)("body", payload.AddressMatchPostRequest, {
        explode: true,
    });
    const path = (0, url_js_1.pathToFunc)("/properties/address-match-v2-exact")();
    const query = (0, encodings_js_1.encodeFormQuery)({
        "fields[property]": payload["fields[property]"],
    });
    const headers = new Headers((0, primitives_js_1.compactMap)({
        "Content-Type": "application/json",
        Accept: "application/json",
    }));
    const requestSecurity = (0, security_js_1.resolveSecurity)([
        {
            fieldName: "Authorization",
            type: "http:bearer",
            value: security?.bearer,
        },
    ], [
        {
            fieldName: "x-api-key",
            type: "apiKey:header",
            value: security?.xApiKey,
        },
    ]);
    const context = {
        baseURL: options?.serverURL ?? client._baseURL ?? "",
        operationID: "post_address_match_v2_properties_address_match_v2_exact_post",
        oAuth2Scopes: [],
        resolvedSecurity: requestSecurity,
        securitySource: security,
        retryConfig: options?.retries
            || client._options.retryConfig
            || { strategy: "none" },
        retryCodes: options?.retryCodes || ["429", "500", "502", "503", "504"],
    };
    const requestRes = client._createRequest(context, {
        security: requestSecurity,
        method: "POST",
        baseURL: options?.serverURL,
        path: path,
        headers: headers,
        query: query,
        body: body,
        timeoutMs: options?.timeoutMs || client._options.timeoutMs || -1,
    }, options);
    if (!requestRes.ok) {
        return [requestRes, { status: "invalid" }];
    }
    const req = requestRes.value;
    const doResult = await client._do(req, {
        context,
        errorCodes: ["400", "404", "422", "429", "4XX", "500", "5XX"],
        retryConfig: context.retryConfig,
        retryCodes: context.retryCodes,
    });
    if (!doResult.ok) {
        return [doResult, { status: "request-error", request: req }];
    }
    const response = doResult.value;
    const responseFields = {
        HttpMeta: { Response: response, Request: req },
    };
    const [result] = await M.match(M.json(200, operations
        .PostAddressMatchV2PropertiesAddressMatchV2ExactPostResponsePostAddressMatchV2PropertiesAddressMatchV2ExactPost$inboundSchema), M.jsonErr(422, errors.FastAPIErrorAttributes$inboundSchema), M.jsonErr([400, 404, 429], errors.KrakenErrorAttributes$inboundSchema), M.jsonErr(500, errors.KrakenErrorAttributes$inboundSchema), M.fail("4XX"), M.fail("5XX"))(response, { extraFields: responseFields });
    if (!result.ok) {
        return [result, { status: "complete", request: req, response }];
    }
    return [result, { status: "complete", request: req, response }];
}
//# sourceMappingURL=propertiesPostAddressMatchV2PropertiesAddressMatchV2ExactPost.js.map